import { render, staticRenderFns } from "./BlockResult.vue?vue&type=template&id=4f4f6b44"
import script from "./BlockResult.vue?vue&type=script&lang=js"
export * from "./BlockResult.vue?vue&type=script&lang=js"
import style0 from "./BlockResult.vue?vue&type=style&index=0&id=4f4f6b44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports